"use client";

import { usePostHog } from "posthog-js/react";

import { FlowNavigationContext } from "../constants";

export const useFlowNavigationContext = (): FlowNavigationContext => {
  const posthog = usePostHog();

  const inABTestGroup = (flag: string): boolean => {
    if (!posthog) { return false; }
    const flagValue = posthog.getFeatureFlag(flag);
    return flagValue === "test";
  };

  const constraints: FlowNavigationContext = {
    inABTestGroup,
  };

  return constraints;
};
